import Box from '@mui/material/Box';
import { ReactNode } from 'react';

export const ProductBox = (
  {
    id,
    widthConfig,
    children,
  }: {
    id: string;
    widthConfig?: Record<string, string>;
    children?: ReactNode;
  },
) => (
  <Box
    key={id}
    id={id}
    display="flex"
    sx={theme => ({
      minHeight: theme.spacing(30),
      padding: theme.spacing(1),
      [theme.breakpoints.down('tablet')]: {
        width: widthConfig?.tablet ?? '100%',
        padding: theme.spacing(2, 0),
      },
      [theme.breakpoints.between('tablet', 'dsm')]: {
        width: widthConfig?.dsm ?? '50%',
      },
      [theme.breakpoints.between('dsm', 'dxl')]: {
        width: widthConfig?.dxl ?? '33%',
      },
      [theme.breakpoints.up('dxl')]: {
        width: '25%',
      },
    })}
  >
    <Box
      id={`${id}-box`}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      padding={3}
      width="100%"
      border="2px solid #5959EB"
      boxShadow={theme => theme.shadows[1]}
    >
      {children}
    </Box>
  </Box>
);
